import { IRecordFurtherEducationGroupEditItem, RecordFurtherEducationGroupEditItem } from "./recordFurtherEducationGroupEditItem";

export interface IRecordFurtherEducationGroupEdit {
    educationGroup: IRecordFurtherEducationGroupEditItem;
}

export class RecordFurtherEducationGroupEdit implements IRecordFurtherEducationGroupEdit {
    educationGroup: RecordFurtherEducationGroupEditItem;

    constructor();
    constructor(obj: IRecordFurtherEducationGroupEdit);
    constructor(obj?: any) {
        this.educationGroup = new RecordFurtherEducationGroupEditItem(obj ? obj.educationGroup : null);
    }
}